<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
        {{ "bikeshop.shop_setup.card_headers.rentals_widget" | translate }}
      </span>
    </div>
  </div>

  <div *ngIf="!loading">
    <form [formGroup]="configForm" (ngSubmit)="saveConfig(configForm.value)">
      <div>
        <div class="row">
          <div class="col-md-12">
            <div class="content">

              <!-- <div class="row margin-top-8" *ngIf="parentIdentifier && parentIdentifier.length > 0">
                <div class="col-md-3 label">
                  {{ "bikeshop.shop_ride_configuration.use_for_all_linked_stores" | translate }}:
                </div>
                <div class="col-md-1">
                  <div class="p-inputgroup">
                    <p-inputSwitch formControlName="useSettingForAllLinkedStores"></p-inputSwitch>
                  </div>
                </div>
              </div> -->


              <div class="row margin-top-8">
                <div class="col-md-4 label bold">
                  {{
                  "bikeshop.rentals_configuration.theme" | translate
                  }}:
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{
                  "bikeshop.shop_ride_configuration.primary_colour" | translate
                  }}:
                </div>
                <div class="col-md-8">
                  <div style="display: flex;">
                    <div class="color-picker-custom" [ngClass]="{'not-set': !configForm.value.primaryColor}"
                      [ngStyle]="{ 'background-color' : configForm.value.primaryColor }"
                      [colorPicker]="configForm.value.primaryColor"
                      (colorPickerChange)="updateColor($event, 'primaryColor')" cpOutputFormat="hex"
                      cpAlphaChannel="disabled">
                    </div>
                    <span *ngIf="!configForm.value.primaryColor"><small>{{
                        'bikeshop.shop_ride_configuration.colour_not_set' | translate
                        }}</small></span>
                  </div>
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{
                  "bikeshop.shop_ride_configuration.primary_text_colour" | translate
                  }}:
                </div>
                <div class="col-md-9">
                  <div style="display: flex;">
                    <div class="color-picker-custom" [ngClass]="{'not-set': !configForm.value.primaryTextColor}"
                      [ngStyle]="{ 'background-color' : configForm.value.primaryTextColor }"
                      [colorPicker]="configForm.value.primaryTextColor"
                      (colorPickerChange)="updateColor($event, 'primaryTextColor')" cpOutputFormat="hex"
                      cpAlphaChannel="disabled">
                    </div>
                    <span *ngIf="!configForm.value.primaryTextColor"><small>{{
                        'bikeshop.shop_ride_configuration.colour_not_set' | translate
                        }}</small></span>
                  </div>
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{
                  "bikeshop.shop_ride_configuration.secondary_text_color" | translate
                  }}:
                </div>
                <div class="col-md-9">
                  <div style="display: flex;">
                    <div class="color-picker-custom" [ngClass]="{'not-set': !configForm.value.secondaryTextColor}"
                      [ngStyle]="{ 'background-color' : configForm.value.secondaryTextColor }"
                      [colorPicker]="configForm.value.secondaryTextColor"
                      (colorPickerChange)="updateColor($event, 'secondaryTextColor')" cpOutputFormat="hex"
                      cpAlphaChannel="disabled">
                    </div>
                    <span *ngIf="!configForm.value.secondaryTextColor"><small>{{
                        'bikeshop.shop_ride_configuration.colour_not_set' | translate
                        }}</small></span>
                  </div>
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{
                  "bikeshop.shop_ride_configuration.card_background" | translate
                  }}:
                </div>
                <div class="col-md-9">
                  <div style="display: flex;">
                    <div class="color-picker-custom" [ngClass]="{'not-set': !configForm.value.cardBackground}"
                      [ngStyle]="{ 'background-color' : configForm.value.cardBackground }"
                      [colorPicker]="configForm.value.cardBackground"
                      (colorPickerChange)="updateColor($event, 'cardBackground')" cpOutputFormat="hex"
                      cpAlphaChannel="disabled">
                    </div>
                    <span *ngIf="!configForm.value.cardBackground"><small>{{
                        'bikeshop.shop_ride_configuration.colour_not_set' | translate
                        }}</small></span>
                  </div>
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{
                  "bikeshop.shop_ride_configuration.default_background_colour" | translate
                  }}:
                </div>
                <div class="col-md-9">
                  <div style="display: flex;">
                    <div class="color-picker-custom" [ngClass]="{'not-set': !configForm.value.defaultBackgroundColor}"
                      [ngStyle]="{ 'background-color' : configForm.value.defaultBackgroundColor }"
                      [colorPicker]="configForm.value.defaultBackgroundColor"
                      (colorPickerChange)="updateColor($event, 'defaultBackgroundColor')" cpOutputFormat="hex"
                      cpAlphaChannel="disabled"></div>
                    <span *ngIf="!configForm.value.defaultBackgroundColor"><small>{{
                        'bikeshop.shop_ride_configuration.colour_not_set' | translate
                        }}</small></span>
                  </div>
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{
                  "bikeshop.shop_ride_configuration.card_border_radius" | translate
                  }}:
                </div>
                <div class="col-md-2 flex">
                  <div style="width: 100%">
                    <p-slider formControlName="cardBorderRadius" [min]="0" [max]="20"></p-slider>
                  </div>
                </div>
                <div class="col-md-1">
                  {{configForm.value.cardBorderRadius}}px
                </div>
              </div>


              <div class="row margin-top-16">
                <div class="col-md-4 label bold">
                  {{
                  "bikeshop.shop_ride_configuration.custom_fonts" | translate
                  }}:
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-12 label-custom" [ngStyle]="{'font-family': configForm.value.defaultFontName}">
                  {{ "bikeshop.shop_ride_configuration.default_font" | translate }}:
                </div>
                <div class="col-md-12 margin-top-8">
                  <div class="font-options">
                    <div *ngFor="let font of fontOptions" (click)="updateFont(font)"
                      [ngClass]="{'selected':font.value === configForm.value.defaultFontName}"
                      [ngStyle]="{'font-family': font.value}">{{font.value}}</div>
                  </div>
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-12 label-custom">
                  {{ "bikeshop.shop_ride_configuration.secondary_font" | translate }}:
                </div>
                <div class="col-md-12 margin-top-8">
                  <div class="font-options">
                    <div *ngFor="let font of fontOptions" (click)="updateSecondaryFont(font)"
                      [ngClass]="{'selected':font.value === configForm.value.secondaryFontName}"
                      [ngStyle]="{'font-family': font.value}">{{font.value}}</div>
                  </div>
                </div>
              </div>


              <div class="row margin-top-16">
                <div class="col-md-4 label bold">
                  {{
                  "bikeshop.rentals.configuration.google_tag_manager" | translate
                  }}:
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{ "bikeshop.rentals.configuration.google_tag_manager_id" | translate }}:
                </div>
                <div class="col-md-2 margin-top-8">
                  <div class="p-inputgroup">
                    <input pInputText placeholder="GTM-XXXXXXX" maxlength="12"
                      formControlName="googleAnalyticsScript" />
                  </div>
                </div>
              </div>

              <div class="row margin-top-16">
                <div class="col-md-4 label bold">
                  {{
                  "bikeshop.rentals.configuration.facebook_pixel_manager" | translate
                  }}:
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{ "bikeshop.rentals.configuration.facebook_pixel_manager_code" | translate }}:
                </div>
                <div class="col-md-2 margin-top-8">
                  <div class="p-inputgroup">
                    <input pInputText placeholder="XXXXXXX" formControlName="facebookPixel" />
                  </div>
                </div>
              </div>

              <div class="row margin-top-16">
                <div class="col-md-4 label bold">
                  {{ "bikeshop.rentals.configuration.settings" | translate }}:
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{ "bikeshop.rentals.configuration.capture_address" | translate }}:
                </div>
                <div class="col-md-2 margin-top-8">
                  <div class="p-inputgroup">
                    <p-inputSwitch formControlName="captureAddress"></p-inputSwitch>
                  </div>
                </div>
              </div>

              <div class="row margin-top-16">
                <div class="col-md-9"></div>
                <div class="col-md-3">
                  <button type="submit" class="iso-round-button full-width iso-light"
                    [disabled]="!configForm.valid || saving">{{'bikeshop.shop_ride_configuration.save_configuration' |
                    translate}}</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div *ngIf="iFrameCreated && !saving" class="container-fluid" style="margin-top: 48px;">
  <div class="header-container">
    <div class="page-header">
      <span class="fa fa-id-badge"></span>{{ "bikeshop.shop_ride_configuration.widget_preview" | translate }}
    </div>
  </div>
  <div class="content">
    <div class="row" *ngIf="deliveriesEnabled">
      <div class="col-md-2 label bold">{{ 'bikeshop.rentals_configuration.show_deliveries_widget' | translate }}:</div>
      <div class="col-md-2">
        <p-inputSwitch [(ngModel)]="showNonDeliveriesWidget" (onChange)="showDeliveryWidgetChanged()"></p-inputSwitch>
      </div>
      <div class="col-md-8 label">
        <small>{{ 'bikeshop.rentals_configuration.show_deliveries_widget_info' | translate }}</small>
      </div>

    </div>
    <div class="row margin-top-8">
      <div class="col-md-2 label bold">{{ 'bikeshop.rentals_configuration.select_product_categories' | translate }}:
      </div>
      <div class="col-md-2">
        <p-multiSelect [options]="productCategories" [(ngModel)]="selectedProductCategories" [showClear]="false" [showHeader]="false"
          [placeholder]="'bikeshop.rentals_configuration.select_product_categories' | translate"
          (onChange)="showCategoryWidgetChanged($event)"></p-multiSelect>
      </div>
      <div class="col-md-8 label">
        <small>{{ 'bikeshop.rentals_configuration.select_product_categories_description' | translate }}</small>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-2 label bold">{{ 'bikeshop.rentals_configuration.select_product_manufacturer_model' | translate }}:
      </div>
      <div class="col-md-2">
        <p-multiSelect [options]="productGroups" [(ngModel)]="selectedProductGroups" [showClear]="false" [showHeader]="false"
          [placeholder]="'bikeshop.rentals_configuration.select_product_manufacturer_model' | translate"
          (onChange)="showCategoryWidgetChanged($event)"></p-multiSelect>
      </div>
      <div class="col-md-8 label">
        <small>{{ 'bikeshop.rentals_configuration.select_product_manufacturer_model_description' | translate }}</small>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 margin-top-16 flex">
        <!-- <div class="copy-link">
      <input type="text" pInputText [(ngModel)]="dangerousURL" [disabled]="true" />
      <span class="fa fa-clipboard" pTooltip="{{'bikeshop.shop_ride_configuration.copy_link' | translate}}"
        (click)="copyLink()"></span>
    </div> -->
        <div>
          <button pButton class="p-button-raised" label="{{'bikeshop.shop_ride_configuration.copy_link' | translate}}"
            (click)="copyLink()"></button>
        </div>
        <div style="margin-left: 16px">
          <button pButton class="p-button-raised" label="{{'bikeshop.shop_ride_configuration.copy_iframe' | translate}}"
            (click)="copyiFrame()"></button>
        </div>
      </div>
    </div>
    <div class=" row margin-top-16">
      <div class="col-md-12">
        <div style="border: 1px solid transparent;border-radius: 6px;overflow: hidden;"
          [ngStyle]="{'border-color': config.cardBackground || '#CCC'}">
          <iframe [src]="iFrameLink" width="100%" height="1500px" style="border: 0"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>

<p-toast position="top-center" styleClass="hubtiger-toast" key="link-copied"></p-toast>